import { render, staticRenderFns } from "./BetgameContact.vue?vue&type=template&id=725597c5&scoped=true"
import script from "./BetgameContact.vue?vue&type=script&lang=js"
export * from "./BetgameContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725597c5",
  null
  
)

export default component.exports